import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { API_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllModalsData } from "./ModalsAction";

export const getAllModalsDataApi = (ctx = null) => {
    ctx?.setState?.({ isLoading: true })

    return function (dispatch, getState) {
        const params = new URLSearchParams(ctx?.props?.location?.search);
        const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
        const pageSize = parseInt(params.get("pageSize"), 10) || API_LIMIT;
        const pageNumber = parseInt(params.get("page"), 10) || START_PAGE;
        return postLoginInstance.get(`modal?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${pageSize}&pageNumber=${pageNumber}`)
            .then((res) => {

                dispatch(getAllModalsData(res.data.data, pageNumber));
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Something went wrong")
            }).finally(() => {
                ctx?.setState?.({ isLoading: false})
            })
    }

};
export const updateModalApi = async (url, data, ctx = null) => {
    try {
        const response = await postLoginInstance.put(url, data);
        console.log(response)
        if (response.status < 250 && response.status > 199) {
            toast.success("Successfully Updated.")
            ctx.props.getAllModalsDataApi(ctx);
        }
        return response;
    } catch (error) {
        console.log(error)
        toast.error(error?.response?.data?.message || 'Something went wrong.');
        return false;
    }
}